import {
    STATUS_FINE_CANCELLED,
    STATUS_CLAIM_WAITING,
} from './constants'

function buildFeedbacks (feedbacks) {
    return feedbacks.map(f => ({
        comments: f.comments,
        price: f.early_price_qty,
        date: f.date,
        user: f.user,
        resolution: f.resolution,
    }))
}

function buildClaims (claims) {
    return claims.map(c => ({
        feedbacks: buildFeedbacks(c.feedbacks),
        date: c.date,
        user: c.user,
        reason: c.reason,
        status: c.status,
        description: c.description,
    }))
}

export function buildExpandedFine (fine) {
    const vehicle = `${fine.vehicle.brand.name} ${fine.vehicle.model.name}`
    return {
        vehicle,
        claims: buildClaims(fine.claims),
        files: fine.files,
        numberPlate: fine.number_plate,
        parkingName: fine.parking.name,
        parkingTimeZone: fine.parking.timeZone,
        bulletinNumber: fine.bulletin_number,
        reason: fine.description,
        date: fine.date,
        dueDate: fine.due_date,
        dateReducedAmount: fine.due_date_reduced_amount,
        fareQty: fine.fare_qty,
        originalQty: fine.original_fare_qty,
        isCancelled: fine.status === STATUS_FINE_CANCELLED,
        status: fine.status,
        lastFeedbackStatus: fine.last_feedback_status,
    }
}

export function mapFinePayment (request) {
    return {
        bulletinNumber: request.bulletinNumber,
        userName: request.firstName,
        userLastName: request.lastName,
        userEmail: request.email,
        userPhone: request.phone,
        setup_intent_id: request.setupIntentId,
        townId: request.townId,
        brandId: request.brandId,
    }
}

export function buildClaim (claim, townId, bulletinNumber, brandId) {
    return {
        town_id: townId,
        bulletinNumber,
        reason: claim.reason,
        description: claim.description,
        userEmail: claim.email,
        userPhone: claim.phone,
        userAddress: claim.address,
        userName: claim.firstName,
        userSurname: claim.lastName,
        userStateId: claim.provinceId,
        userTown: claim.town,
        userPostCode: claim.postalCode,
        file: claim.files,
        brandId,
    }
}

export function makeClaim (claim) {
    return {
        feedbacks: [],
        date: claim.date,
        user: claim.user,
        reason: claim.reason,
        status: STATUS_CLAIM_WAITING,
        description: claim.description,
    }
}
